import React from "react";
import Footercon from "../components/Footer/Footercon";

const Footer = () => {
  return (
    <footer className="h-full bg-[#FF786F] ">
      <Footercon />
    </footer>
  );
};

export default Footer;
